import React from 'react'

const Title = ({ title }) => {
  return (
      <h3 className="title is-6 space">{title}</h3>
  )
}

export default Title
